import { getEditLocation } from "../../../core/util/functions";
export const alarmsLocation = "/surveilance/alarmsetup";
export const getAlarmsEditLocation = (id?: string) =>
  getEditLocation(alarmsLocation, undefined, id);

export const editRouter = getAlarmsEditLocation(":almId?");
